import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  IE3ConsignmentHouseLevel,
  IE3GoodsItem,
  IE3TransportEquipment
} from "@portbase/bezoekschip-service-typescriptmodels";
import {openEditModal} from "../../../../common/utils";
import {
  MasterConsignmentDetailsComponent,
  MasterConsignmentDetailsComponentData
} from "../master-consignment-details/master-consignment-details.component";
import {
  GoodsConsignmentDetailsComponent,
  GoodsConsignmentDetailsComponentData
} from "../goods-consignment-details/goods-consignment-details.component";
import {
  EquipmentConsignmentDetailsComponent,
  EquipmentConsignmentDetailsComponentData
} from "../equipment-consignment-details/equipment-consignment-details.component";
import {
  HouseConsignmentDetailsComponent,
  HouseConsignmentDetailsComponentData
} from "../house-consignment-details/house-consignment-details.component";
import {Handler} from "../../../../common/handlers/handler";
import {View} from "../../../../common/handlers/view";
import {Observable} from "rxjs";
import {ErrorPointer, ErrorWithPointers} from "../../../../common/errors/errors";

@Component({
    selector: 'app-consignment-details-alerts',
    templateUrl: './consignment-details-alerts.component.html',
    styleUrls: ['./consignment-details-alerts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Handler()
export class ConsignmentDetailsAlertsComponent extends View implements OnInit {
  errors: Observable<ErrorWithPointers[]>;

  ngOnInit() {
    this.errors = this.subscribeTo("getConsignmentErrors");
  }

  getPointersWithDescription = (error: ErrorWithPointers): ErrorPointer[] =>
    error.pointers?.filter(e => e.description);

  openAlertDetails = (error: ErrorWithPointers) => {
    const houseConsignment = error.pointers.find(p => p.type === "houseLevel")?.model as IE3ConsignmentHouseLevel;
    const goodsItem = error.pointers.find(p => p.type === "goodsItem")?.model as IE3GoodsItem;
    const equipment = error.pointers.find(p => p.type === "equipment")?.model as IE3TransportEquipment;

    this.sendQuery("getConsignment").subscribe(c => {
      if (goodsItem) {
        openEditModal(GoodsConsignmentDetailsComponent, <GoodsConsignmentDetailsComponentData>{
          consignmentProcessId: c.consignmentProcessId,
          cachedConsignmentProcess: c,
          houseConsignmentNumber: houseConsignment?.consignmentNumber,
          cachedHouseConsignment: houseConsignment,
          equipmentNumber: equipment?.containerIdentificationNumber,
          goodsItemNumber: goodsItem?.goodsItemNumber
        }, {
          warnOnClose: true,
          currentToStack: true
        });
      } else if (equipment) {
        openEditModal(EquipmentConsignmentDetailsComponent, <EquipmentConsignmentDetailsComponentData>{
          consignmentProcessId: c.consignmentProcessId,
          cachedConsignmentProcess: c,
          houseConsignmentNumber: houseConsignment?.consignmentNumber,
          equipmentNumber: equipment?.containerIdentificationNumber,
          goodsItem: goodsItem
        }, {
          warnOnClose: true,
          currentToStack: true
        });
      } else if (houseConsignment) {
        openEditModal(HouseConsignmentDetailsComponent, <HouseConsignmentDetailsComponentData>{
          consignmentProcessId: c.consignmentProcessId,
          cachedConsignmentProcess: c,
          consignmentNumber: houseConsignment.consignmentNumber
        }, {
          warnOnClose: true,
          currentToStack: true
        });
      } else {
        openEditModal(MasterConsignmentDetailsComponent, <MasterConsignmentDetailsComponentData>{
          consignmentProcessId: c.consignmentProcessId,
          cachedConsignmentProcess: c
        }, {
          warnOnClose: true,
          currentToStack: true
        });
      }
    });
  }
}

